import * as pageProcessing from "./pageProcessing";
import * as eventProcessing from "./eventProcessing";
import * as utilities from "./utilities";
import * as pubSub from "./pubSub";
import * as appData from "./appData";

// Conditional imports.  If not used based on site conditions below webpack will strip these from the bundle.
import * as staticAppMeasure from "./appMeasure";

let visitorAPIisFromCore = false;

var setupModules = async function( ) {

	let appMeasurementInit;

    try {

		appMeasurementInit = staticAppMeasure.init();

		console.log( "ANALYTICSLOG -- appMeasure is loaded: ", appMeasurementInit );
        console.log( "ANALYTICSLOG -- APPCONTROLLER -- window.s", window.s );

		// override must be set up after appMeasure is iniited.
		if (appMeasurementInit.initialized) {
			window._T.deployments.core.appMeasurement = appMeasurementInit.appMeasurementVersion;
		}

    } catch ( error ) {
        console.error( `ANALYTICSLOG -- Error: ${ error }` );
    }

};

var exposeItemsOnInterface = function () {

	// Used to pass events to core analytics upon user action or confirmation of successful action.
	_T.sendPageDataToAnalytics = pageProcessing.sendPageDataToAnalytics;
	_T.sendEventDataToAnalytics = eventProcessing.sendEventDataToAnalytics;
	_T.pageData = pageProcessing.pageDataArray();

};

var processTempPageData = function () {

	var _tempPageData = ( typeof _T.pageData !== 'undefined' && _T.pageData.constructor === Array && _T.pageData.length ? _T.pageData[ _T.pageData.length - 1 ] : "" );

	exposeItemsOnInterface();

	if ( _tempPageData ) {
		appData.addUpdateCache( "beaconExecutionType", "preignition" );
		_T.pageData.push( _tempPageData );
	}

};

var run = async function( ddo ) {

    utilities.validateDataObj( ddo );

	var _tempEventData = ( _T.eventData ? _T.eventData : [] );

	/* Set TRON Cache and add pageName */
    appData.addUpdateCache( "pageName", typeof ddo.page.pageInfo.pageName === "string" ? ddo.page.pageInfo.pageName.toLowerCase() : '' );

    await setupModules( ddo );

    await eventProcessing.processPreIgnitionEvents( _tempEventData );

	processTempPageData();

};


let continueInitialization = function() {

	if ( !_T.PUB_SUB ) {
		_T.PUB_SUB = pubSub.init();
	}

	window._T.deployments.core.visitorAPI = ( typeof ( Visitor ) !== "undefined" ? "VisitorAPI Present" : "VisitorAPI Missing" );
    window._T.deployments.core.visitorAPIisFromCore = visitorAPIisFromCore;
    window._T.deployments.core.versions.visitorAPI = Visitor.getInstance( "A90D3BC75245B0C90A490D4D@AdobeOrg" ).version;

    run( window.digitalData );

};

( function() {
    // An indicator for build_local mappings
    console.log( '%c ANALYTICSLOG -- Local Build Mapping: Core | ' + CODE_VERSION + ' | ' + BUILD_TARGET + ' | 2024-09-25T20:18:13.000Z', 'background: orange; color: white; display: block; line-height:20px; padding:5px 30px; border: 1px solid red; font-size:1em;' );

    window._T = ( window._T ? _T : {} );

    window.digitalData = ( window.digitalData ? digitalData : {
        event: []
    } );

    _T.pageData = ( _T.pageData ? _T.pageData : [] );
    _T.eventData = ( _T.eventData ? _T.eventData : [] );

    window._T.deployments = ( _T.deployments ? _T.deployments : {} );

    window._T.deployments.core = {
        build: BUILD_TARGET,
        versions: {
            core: CODE_VERSION
        },
        ts: '2024-09-25T20:18:13.000Z'
    };

	continueInitialization();

} )();